<template>
	<div>加载中</div>
</template>

<script>

export default {
	
    data() {
        return {
			
        }
    },
	
	created() {
		
		const url = new URL(window.location.href);
		const params = new URLSearchParams(url.search);
		
		// 获取特定参数的值
		const token = params.get('token');
		const fromPath = params.get('fromPath');
		window.localStorage.setItem('APP','WMS')
		
		console.log(token); // '11'
		console.log(fromPath); // '1'
		window.localStorage.setItem('NMYDATAASSTSTOKEN', token)
		window.localStorage.setItem('fromPath', fromPath)
		this.$router.replace(
			{path:'/wms'}
		)
	},
	methods:{
		
	}
	

};
</script>

<style>
</style>